import { render } from "./wfm-modal.vue?vue&type=template&id=8bdd281c"
import script from "./wfm-modal.vue?vue&type=script&lang=js"
export * from "./wfm-modal.vue?vue&type=script&lang=js"

import "./wfm-modal.vue?vue&type=style&index=0&id=8bdd281c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__